import React, { useState } from 'react';
import { withRouter } from 'react-router';

import OnboardingWrapper from './OnboardingWrapper';
import SelectSurveyModal from './Modal/SelectSurvey';
import { BusinessCustomSurvey } from '../Business-admin/MenuRedirect';

const SelectSurvey = (props) => {
  const { path } = props.match;
  const [isModalActive, setModalStatus] = useState(false);
  const [isFirstModalActive, setFirstModalStatus] = useState(false);

  return (
    <OnboardingWrapper isModalActive={isModalActive || isFirstModalActive}>
      <SelectSurveyModal
        setModalStatus={(status) => setFirstModalStatus(status)}
        path={path}
      />
      <BusinessCustomSurvey setModalStatus={(status) => setModalStatus(status)} />
    </OnboardingWrapper>
  );
}

export default withRouter(SelectSurvey);



// WEBPACK FOOTER //
// ./src/components/Onboarding/SelectSurvey.js